import {
    chakra,
    Flex,
    Box,
    HStack
} from '@chakra-ui/react';

export const HeaderBackground = chakra(Flex, {
    label: 'HeaderBackground',
    baseStyle: {
        fontFamily: 'Poppins, , sans-serif',
        position: 'absolute',
        top: '0',
        justifyContent: 'space-between',
        alignItems: 'center',
        h: '60px',
        w: '100%',
        bgColor: 'white',
        boxShadow: '71px 0 8px 0 rgba(15, 25, 42, 0.16)',
        zIndex: 1003
    }
});

export const HeaderAppButton = chakra(Box, {
    label: 'HeaderAppButton',
    baseStyle: {
        backgroundColor: 'primary.700',
        h: '60px',
        minWidth: '70px',
        borderBottom: '1px solid',
        borderColor: 'primary.700'
    }
});

export const HeaderMain = chakra(Flex, {
    label: 'HeaderMain',
    baseStyle: {
        width: '100%',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: '0 15px'
    }
});

export const ProductWrapper = chakra(Flex, {
    label: 'ProductWrapper',
    baseStyle: {
        flex: 1,
        alignItems: 'center',
        gap: '16px'
    }
});

export const LinksContainer = chakra(Flex, {
    label: 'LinksContainer',
    baseStyle: {
        w: 'auto',
        alignItems: 'center',
        justifyContent: 'end'
    }
});

export const LinksWrapper = chakra(HStack, {
    label: 'LinksWrapper',
    baseStyle: {
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: {
            base: '8px',
            tablet: '12px',
            portrait: '12px'
        }
    }
});

export const Divider = chakra(Box, {
    baseStyle: {
        w: '1px',
        h: '32px',
        backgroundColor: '#DBE0E6'
    }
});

export const SchoolName = chakra(Flex, {
    label: 'Header - School Name',
    baseStyle: {
        w: '100%',
        alignItems: 'center'
    }
});
